import * as types from 'modules/brands/actionsType';
import type { BrandsUiState } from 'modules/brands/selectors/types';
import { createReducer } from 'utils/ReduxUtils';

const initialState: BrandsUiState = {
  fetching: false,
  updating: false,
  apiError: null,
  search: null,
};

const fetchingBrandsReducer = (state: BrandsUiState): BrandsUiState => ({
  ...state,
  fetching: true,
  apiError: null,
});

const fetchingBrandsFailureReducer = (state: BrandsUiState, { payload }: { payload: unknown }): BrandsUiState => ({
  ...state,
  fetching: false,
  apiError: payload,
});

const fetchingBrandsSuccessReducer = (state: BrandsUiState): BrandsUiState => ({
  ...state,
  fetching: false,
  apiError: null,
});

export default createReducer<BrandsUiState>(initialState, {
  // Fetching
  [types.FETCH_ALL_BRANDS_REQUEST]: fetchingBrandsReducer,
  [types.FETCH_BRAND_REQUEST]: fetchingBrandsReducer,
  [types.FETCH_BRANDS_BY_DEALER_REQUEST]: fetchingBrandsReducer,
  [types.FETCH_BRANDS_BY_GROUP_REQUEST]: fetchingBrandsReducer,
  // Stop fetching (failed)
  [types.FETCH_ALL_BRANDS_FAILURE]: fetchingBrandsFailureReducer,
  [types.FETCH_BRAND_FAILURE]: fetchingBrandsFailureReducer,
  [types.FETCH_BRANDS_BY_DEALER_FAILURE]: fetchingBrandsFailureReducer,
  [types.FETCH_BRANDS_BY_GROUP_FAILURE]: fetchingBrandsFailureReducer,
  // Stop fetching (succeed)
  [types.FETCH_ALL_BRANDS_SUCCESS]: fetchingBrandsSuccessReducer,
  [types.FETCH_BRAND_SUCCESS]: fetchingBrandsSuccessReducer,
  [types.FETCH_BRANDS_BY_DEALER_SUCCESS]: fetchingBrandsSuccessReducer,
  [types.FETCH_BRANDS_BY_GROUP_SUCCESS]: fetchingBrandsSuccessReducer,
});
